"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
// TODO: According to https://polaris.corp.amazon.com/system/structures/help_panel/ the official
//  help panel widget is coming soon. We should switch to that when it arrives
const HelpPanel = ({ title, content, links }) => (
// TODO: This doesn't display correctly yet
React.createElement("div", { className: "awsui-util-help-panel" },
    React.createElement("div", { className: "awsui-util-help-panel-header" },
        React.createElement("h2", null, title)),
    content,
    links && (React.createElement("div", { className: "awsui-util-help-panel-footer" },
        React.createElement("h3", null,
            "Learn more ",
            React.createElement(polaris_1.Icon, { name: "external" })),
        React.createElement("ul", null, links.map((link) => (React.createElement("li", { key: link.url },
            React.createElement("a", { href: link.url }, link.label)))))))));
exports.default = HelpPanel;
//# sourceMappingURL=HelpPanel.js.map